import { ApiCall } from "../apiBase";

/********Send forgot password email********/
export async function sendForgotPasswordEmail(email) {
  const result = await ApiCall({
    method: "post",
    data: {
      query: `
          mutation GenerateResetPasswordEmailMutation($generateResetPasswordEmailInput: ResetTicketInput) {
            generateResetPasswordEmail(input: $generateResetPasswordEmailInput) {
              message
              code
            }
          }
        `,
      variables: {
        generateResetPasswordEmailInput: {
          email,
        },
      },
    },
  });

  let forgotPasswordResponse = null;

  if (
    !result.data.data.generateResetPasswordEmail &&
    result.data.errors &&
    result.data.errors.length > 0
  ) {
    forgotPasswordResponse = result.data.errors[0].message;
  }

  return forgotPasswordResponse;
}

/********Reset current password********/
export async function resetCurrentPassword(email, oldPassword, newPassword) {
  const result = await ApiCall({
    method: "post",
    data: {
      query: `
      mutation GenerateResetPasswordEmailMutation($resetPasswordInput: ResetPasswordInput) {
        resetPassword(input: $resetPasswordInput) {
          message
          code
        }
      }
      `,
      variables: {
        resetPasswordInput: {
          email,
          oldPassword,
          newPassword,
        },
      },
    },
  });

  let resetPasswordResponse = null;

  if (
    !result.data.data.resetPassword &&
    result.data.errors &&
    result.data.errors.length > 0
  ) {
    resetPasswordResponse = result.data.errors[0].message;
  }

  return resetPasswordResponse;
}

/********Reset current password********/
export async function updateForgottenPassword(token, password) {
  const result = await ApiCall({
    method: "post",
    data: {
      query: `
        mutation GenerateResetPasswordEmailMutation($resetForgotPasswordInput: UpdatePasswordInput) {
          resetForgotPassword(input: $resetForgotPasswordInput) {
            message
            code
          }
        }
        `,
      variables: {
        resetForgotPasswordInput: {
          token: token,
          password: password,
        },
      },
    },
  });

  let resetPasswordResponse = null;

  if (
    !result.data.data.resetPassword &&
    result.data.errors &&
    result.data.errors.length > 0
  ) {
    resetPasswordResponse = result.data.errors[0].message;
  }

  return resetPasswordResponse;
}
